import {
    Select,
    SelectContent,
    SelectItem,
    SelectList,
    SelectTrigger,
    SelectValue,
} from '@plato/ui/components/select';
import { useTranslation } from 'react-i18next';
import { ActivityFeedModelType } from '../../../server/types/customer-activity-feed-types.ts';

type Props = {
    value: ActivityFeedModelType | undefined;
    onChange: (modelType: ActivityFeedModelType | undefined) => void;
    /** Which model types to offer (in addition to the always-present "All" option). */
    options: ActivityFeedModelType[];
};

const ALL_VALUE = 'ALL';

export function ActivityModelTypeSelect({ value, onChange, options }: Props) {
    const { t } = useTranslation('customer-detail');

    const getLabel = (modelType: ActivityFeedModelType): string => {
        switch (modelType) {
            case ActivityFeedModelType.QUOTE:
                return t('customer_detail__quotes');
            case ActivityFeedModelType.ORDER:
                return t('customer_detail__orders');
            case ActivityFeedModelType.NOTE:
                return t('customer_detail__notes');
            case ActivityFeedModelType.TASK:
                return t('customer_detail__tasks');
            case ActivityFeedModelType.INSIGHT_OUTCOME:
                return t('customer_detail__insight_outcomes');
            case ActivityFeedModelType.CUSTOMER_STATUS_CHANGE:
                return t('customer_detail__status_changes');
        }
    };

    // The union keeps the sentinel out of what `onChange` is handed.
    const items: { value: ActivityFeedModelType | typeof ALL_VALUE; label: string }[] = [
        { value: ALL_VALUE, label: t('customer_detail__all_activities') },
        ...options.map((modelType) => ({ value: modelType, label: getLabel(modelType) })),
    ];

    return (
        <Select
            title={t('navigation_tab__activities')}
            items={items}
            value={value ?? ALL_VALUE}
            onValueChange={(next) => {
                onChange(next === ALL_VALUE ? undefined : next);
            }}
        >
            <SelectTrigger>
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                <SelectList>
                    {(item: (typeof items)[number]) => <SelectItem key={item.value} value={item} />}
                </SelectList>
            </SelectContent>
        </Select>
    );
}
